const dateIsToday = date => {
  const today = new Date();
  const comparedDate = new Date(date);
  return (
    comparedDate.getFullYear() === today.getFullYear() &&
    comparedDate.getMonth() === today.getMonth() &&
    comparedDate.getDate() === today.getDate()
  );
};

export default dateIsToday;
